import React, { useState, useEffect,useRef } from "react";
import { Button, FormControl, Form } from "react-bootstrap";
import axios from "axios";
import { decryptId } from "../../utils/helpers";


const API_URL = process.env.REACT_APP_API_URL;
function Th18to20Weeks({ source, sampleId }) {
    const labelBox = {
        backgroundColor: "#DFF5F1",
        padding: "12px 30px",
        borderRadius: "10px",
        border: "2px solid #4DB6AC",
        fontWeight: "bold",
        fontSize: "20px",
        textAlign: "center",
        minWidth: "200px"
    };


    const [file, setFile] = useState(null);
    const [remark, setRemark] = useState("");
    const [followup11daysData, setFollowup11daysData] = useState(null);

    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const decodedId = decodeURIComponent(sampleId);
    const id_sample = decryptId(decodedId);
    const alertShown = useRef(false);


    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) return;

        axios.get(`${API_URL}/get_18_to_20_days_data/${id_sample}`, {
            headers: { Authorization: `Bearer ${token}` }, params: { followup_type: source }
        })
            .then((res) => {
                const data = res.data.followup11daysData;
                if (!data) return;

                setFollowup11daysData(data);
                setRemark(data.remark ?? "");
            })
            .catch((err) => console.error(err));
    }, [id_sample, source]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!followup11daysData) return alert("Data not loaded yet");

        const token = localStorage.getItem("token");

        const formData = new FormData();
        formData.append("sample_id", followup11daysData.sample_id);
        if (file) formData.append("Anamoly_scan_file_path", file);
        formData.append("remark", remark || "");
        formData.append("followup_type", source || "");

        try {
            const res = await axios.post(
                `${API_URL}/add_followup_18_to_20_data/${followup11daysData.followup_id}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data"
                    }
                }
            );

            // alert(res.data.message || "Saved successfully");

            setSuccessMsg(
                res.data.message || `Clinical Pregnancy data ${source} saved successfully`
            ); setErrorMsg("");

            setTimeout(() => setSuccessMsg(""), 1000);
        } catch (err) {
            console.error(err);
            // alert("Error saving follow-up data");
            setErrorMsg("Error saving follow-up data");

            setTimeout(() => setErrorMsg(""), 1000);
        }
    };

    return (

        <div
            style={{

                minHeight: "70vh",
                textAlign: "center"
            }}
        >
            <h6 style={{ textAlign: "left" }}>
                {<>18<sup>th</sup>to 20<sup>th</sup>weeks</>}
            </h6>
            {successMsg && (
                <div className="alert alert-success mt-2">
                    {successMsg}
                </div>
            )}

            {errorMsg && (
                <div className="alert alert-danger mt-2">
                    {errorMsg}
                </div>
            )}
            <Form onSubmit={handleSubmit}>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "center",
                        gap: "80px",
                        marginBottom: "40px", padding: "50px",

                    }}
                >
                    <div style={labelBox}>Anamoly scan data</div>
                    <Form.Control
                        type="file"
                        accept=".jpg,.jpeg,.png,.pdf,.svg" style={{
                            width: "400px",
                            height: "38px"
                        }}
                        onChange={(e) => setFile(e.target.files[0])}

                    />
                    {followup11daysData?.Anamoly_scan_file_path ? (
                        <a
                            href={`${API_URL}/documents/${followup11daysData.Anamoly_scan_file_path.split('/').pop()}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ marginLeft: "10px", fontWeight: "500", color: "#007bff", textDecoration: "underline" }}
                        >
                            View File
                        </a>
                    ) : (
                        <Form.Label style={{ marginLeft: "10px" }}>No file uploaded</Form.Label>
                    )}
                </div>


                <div className="mb-3">
                    <FormControl
                        as="textarea"
                        rows={2}
                        placeholder="Enter remarks here"
                        value={remark}
                        onChange={(e) => setRemark(e.target.value)}
                        style={{ width: "1000px", marginTop: "30px" }}
                    />
                </div>
                <div className="d-flex justify-content-center mt-4">
                    <Button
                        type="submit"
                        variant="primary"
                        className="px-4 mb-4"
                    >
                        Save
                    </Button>
                </div>
            </Form>
        </div>
    );
}

export default Th18to20Weeks;  
